import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-66">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-67">
        <img src="https://cdn.magicpatterns.com/uploads/riaWofRCZdVVCoMKtK5Jkp/Nueva_Hero.png" alt="Reflexión nocturna" className="w-full h-full object-cover object-center" data-id="element-68" />
        <div className="absolute inset-0 bg-dark-900/45" data-id="element-69"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900/20 via-transparent to-dark-900" data-id="element-70"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 pt-12 pb-8" data-id="element-71">
        <div className="max-w-5xl mx-auto text-center" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-center" data-id="element-73">
            <img src="https://cdn.magicpatterns.com/uploads/6U3sZzd2tkvNbYBVXvJwRG/Final_LOGO-Jen-ChatGPT_Suggestion-removebg-preview.png" alt="Proyecto ARCA logo" className="w-10 h-10 md:w-12 md:h-12 mb-3 object-contain" style={{
            filter: 'brightness(0) invert(1) opacity(0.7)'
          }} data-id="element-74" />
            <span className="inline-block py-1.5 px-4 border border-brand-muted/30 rounded-full text-xs font-medium tracking-widest text-brand-light uppercase mb-6" data-id="element-75">
              Proyecto ARCA · Ebook
            </span>
          </motion.div>

          <motion.h1 className="text-5xl md:text-7xl lg:text-8xl leading-[0.9] mb-6 text-brand-light" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-76">
            DEJA DE CUESTIONAR TU DOLOR Y EMPIEZA A{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-300 to-gray-500" data-id="element-77">
              RECONSTRUIR TU VALOR.
            </span>
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-brand-light/80 leading-relaxed mb-8 max-w-3xl mx-auto font-light" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} data-id="element-78">
            Domina la psicología detrás de tu ruptura y deja de aceptar migajas.
            Transforma el vacío que dejó ese "casi algo" en el impulso
            definitivo para recuperar tu valor y cambiar las reglas del juego.
          </motion.p>

          <motion.a href="https://www.construyetuarca.com/cart/46478917959841:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-4 bg-brand-light text-dark-900 font-medium text-lg rounded-full overflow-hidden transition-transform hover:scale-105" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease: 'easeOut'
        }} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} data-id="element-79">
            <span className="relative z-10 flex items-center gap-2" data-id="element-80">
              Quiero mi guía y empezar mi proceso
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-81" />
            </span>
            <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity" data-id="element-82"></div>
          </motion.a>
        </div>
      </div>
    </section>;
}